// removed by extract-text-webpack-plugin
module.exports = {"outer":"index__outer___eUXlS","language-button":"index__language-button___3wQGD","languageButton":"index__language-button___3wQGD","wrap":"index__wrap___2QeCf","icon":"index__icon___3dKEJ","dropdown":"index__dropdown___3a6_u","item":"index__item___19pJs"};


//////////////////
// WEBPACK FOOTER
// ./src/components/atoms/LanguageButton/index.css
// module id = 989
// module chunks = 37